module.exports = __webpack_public_path__ + "static/media/nichting.70a1e644.jpg";